import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
export function ProofSection() {
  const testimonials = [{
    quote: 'Llevaba cuatro meses lavando el sillón cada dos días. Probé de todo y nada duraba. Con el protocolo entendí que estaba limpiando mal y que la caja estaba en el lugar equivocado. En menos de una semana los accidentes bajaron muchísimo.',
    name: 'Valentina G.',
    location: 'Buenos Aires'
  }, {
    quote: 'Mi gata empezó a orinar en la cama después de que me mudé. Seguí el plan de 72 horas y a los cinco días dejó de hacerlo. Ojalá lo hubiera tenido antes.',
    name: 'Rodrigo M.',
    location: 'Córdoba'
  }];
  return <section className="w-full bg-white py-6 md:py-20 px-4 md:px-6" data-id="element-321">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-3xl mx-auto" data-id="element-322">
        <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-bold text-[#1C1C1C] mb-5 md:mb-8 text-center" data-id="element-323">
          ¿Qué cambia en 7 días?
        </h2>

        <div className="space-y-6" data-id="element-324">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="bg-[#FAFAF7] rounded-xl p-5 md:p-8 border border-[#1C1C1C]/5" data-id="element-325">
              <QuoteIcon className="w-6 h-6 text-[#2D8C5A]/30 mb-3" data-id="element-326" />
              <p className="text-lg text-[#1C1C1C] leading-relaxed mb-4 italic" data-id="element-327">
                "{testimonial.quote}"
              </p>
              <p className="text-sm font-semibold text-[#2D8C5A]" data-id="element-328">
                — {testimonial.name}, {testimonial.location}
              </p>
            </motion.div>)}
        </div>
      </motion.div>
    </section>;
}